export const getIfsBusinessUnitLabel = (option) => {
  if (!option) return '';
  return [option.business_unit_code, option.business_unit_name]
    .filter(Boolean)
    .join(' - ');
};

export const getIfsOptionLabel = (option) => {
  if (!option) return '';
  const businessUnit = getIfsBusinessUnitLabel(option);
  return [option.project_code, option.project_name, businessUnit]
    .filter(Boolean)
    .join(' - ');
};

export const readOnlyIfsFieldSx = {
  '& .MuiInputBase-input': {
    backgroundColor: 'action.hover',
    cursor: 'default',
  },
};
